import { Entity, Field } from "typegraph";

import Organization from "./Organization";

@Entity({one: "organizationParticipant", many: "userOrganizationParticipants"})
export default class OrganizationParticipant {

	@Field()
	public id: string;

	@Field({entity: Organization})
	public organization: Organization;

}



// WEBPACK FOOTER //
// ./src/panels/organizationParticipant/entities/OrganizationParticipant.ts